import * as React from 'react';
import { useFragment } from 'react-relay';
import { pictureBlockFragment } from './PictureBlock.relay';
import { pictureBlockClassName } from './lib/PictureBlockStyles';
import type { PictureBlockPropsType } from './types';

const PictureBlock: React.FC<PictureBlockPropsType> = ( props: PictureBlockPropsType ) => {
    const contentBlock = useFragment( pictureBlockFragment, props.contentBlock );

    return (
        <div className={pictureBlockClassName}>
            {contentBlock.title !== '' && <h3>{contentBlock.title}</h3>}
            <img src={ contentBlock.url } alt={ contentBlock.altText } />
        </div>
    );
};

export { PictureBlock };
